import { buildMockLiveSearchFillUrl } from './mock-livesearch-fill';

/**
 * @param {string | null} text
 * @param {string | null} [icon]
 * @param {string | null} [iconColor]
 * @returns {ApiLiveSearchTextWithIcon}
 */
function textWithIcon(text, icon = null, iconColor = null) {
  return { text, icon, iconColor };
}

/**
 * @param {string | null} libText
 * @param {string | null} valueText
 * @param {{
 *   libIcon?: string | null,
 *   libIconColor?: string | null,
 *   valueIcon?: string | null,
 *   valueIconColor?: string | null,
 * }} [opts]
 * @returns {ApiLiveSearchResultCell}
 */
function cell(libText, valueText, opts = {}) {
  return {
    lib: textWithIcon(libText, opts.libIcon ?? null, opts.libIconColor ?? null),
    value: textWithIcon(valueText, opts.valueIcon ?? null, opts.valueIconColor ?? null),
  };
}

/**
 * @param {ApiLiveSearchResultCell[]} values
 * @returns {ApiLiveSearchResultRow}
 */
function row(...values) {
  return { values };
}

/** @type {ApiLiveSearchResponse} */
export const mockLiveSearchEmpty = {
  results: [],
};

/** @type {ApiLiveSearchResponse} */
export const mockLiveSearchSingleNoAutoSubmit = {
  results: [
    {
      id: 'result-1',
      title: 'Jean Dupont',
      subTitle: 'Heeds',
      actif: true,
      rows: [
        row(cell(null, 'Directeur technique')),
        row(cell(null, 'jean.dupont@example.com')),
        row(
          cell('Synchronisation', 'oui'),
          cell('Actif', 'oui'),
          cell('Staff', 'non'),
        ),
      ],
      actions: [
        {
          lib: 'Affecter',
          icon: 'fal fa-link',
          fields: [],
          urls: {
            autoSubmitUrl: null,
            fieldsUrl: buildMockLiveSearchFillUrl('result-1', 'contact'),
          },
        },
        {
          lib: 'Copier la structure',
          icon: 'fal fa-home',
          fields: [],
          urls: {
            autoSubmitUrl: null,
            fieldsUrl: buildMockLiveSearchFillUrl('result-1', 'structure'),
          },
        },
        {
          lib: 'Copier l\'individu',
          icon: 'fal fa-user',
          fields: [],
          urls: {
            autoSubmitUrl: null,
            fieldsUrl: buildMockLiveSearchFillUrl('result-1', 'contact'),
          },
        },
        {
          lib: 'Modifier',
          icon: 'fal fa-pen-to-square',
          fields: [],
          urls: {
            autoSubmitUrl: null,
            fieldsUrl: buildMockLiveSearchFillUrl('result-1', 'edit'),
          },
        },
      ],
    },
  ],
};

/** @type {ApiLiveSearchResponse} */
export const mockLiveSearchSingleAutoSubmit = {
  results: [
    {
      id: 'result-2',
      title: 'Marie Martin',
      subTitle: 'Heeds',
      actif: true,
      rows: [
        row(cell(null, 'Chargée de production')),
        row(cell(null, 'marie.martin@example.com')),
        row(
          cell('Synchronisation', 'oui'),
          cell('Actif', 'oui'),
          cell('Staff', 'oui'),
        ),
      ],
      actions: [
        {
          lib: 'Affecter',
          icon: 'fal fa-link',
          fields: [],
          urls: {
            autoSubmitUrl: '/form/submit/live-search-affect',
            fieldsUrl: null,
          },
        },
      ],
    },
  ],
};

/** @type {ApiLiveSearchResponse} */
export const mockLiveSearchSingleEditSendForm = {
  results: [
    {
      id: 'result-3',
      title: 'Pierre Bernard',
      subTitle: 'Zenith Productions',
      actif: true,
      rows: [
        row(cell(null, 'Régisseur')),
        row(cell(null, 'pierre.bernard@example.com')),
        row(
          cell('Synchronisation', 'non'),
          cell('Actif', 'oui'),
          cell('Staff', 'non'),
        ),
      ],
      actions: [
        {
          lib: 'Modifier',
          icon: 'fal fa-pen-to-square',
          fields: [],
          urls: {
            autoSubmitUrl: null,
            fieldsUrl: buildMockLiveSearchFillUrl('result-3', 'edit'),
          },
        },
      ],
    },
  ],
};

/** @type {ApiLiveSearchResponse} */
export const mockLiveSearchInactive = {
  results: [
    {
      id: 'result-inactive',
      title: 'Edwards Elliot',
      subTitle: 'Archivé',
      actif: false,
      rows: [
        row(cell(null, 'Consultant')),
        row(cell(null, 'edwards.elliot@example.com')),
        row(
          cell('Synchronisation', 'non'),
          cell('Actif', 'non'),
          cell('Staff', 'non'),
        ),
      ],
      actions: [
        {
          lib: 'Affecter',
          icon: 'fal fa-link',
          fields: [],
          urls: {
            autoSubmitUrl: null,
            fieldsUrl: buildMockLiveSearchFillUrl('result-inactive', 'contact'),
          },
        },
      ],
    },
  ],
};

/** @type {ApiLiveSearchResponse} */
export const mockLiveSearchMultiple = {
  results: [
    {
      id: 'result-a',
      title: 'Paul Bernard',
      subTitle: 'Heeds',
      actif: true,
      rows: [
        row(cell(null, 'Producteur')),
        row(cell(null, 'paul@example.com')),
        row(
          cell('Synchronisation', 'oui'),
          cell('Actif', 'oui'),
          cell('Staff', 'non'),
        ),
      ],
      actions: [
        {
          lib: 'Affecter',
          icon: 'fal fa-link',
          fields: [],
          urls: {
            autoSubmitUrl: null,
            fieldsUrl: buildMockLiveSearchFillUrl('result-a', 'contact'),
          },
        },
      ],
    },
    {
      id: 'result-b',
      title: 'Sophie Leroy',
      subTitle: null,
      actif: false,
      rows: [
        row(cell(null, null)),
        row(
          cell('Synchronisation', null),
          cell('Actif', 'non'),
          cell('Staff', 'non'),
        ),
      ],
      actions: [
        {
          lib: 'Affecter',
          icon: 'fal fa-link',
          fields: [],
          urls: {
            autoSubmitUrl: null,
            fieldsUrl: buildMockLiveSearchFillUrl('result-b', 'contact'),
          },
        },
      ],
    },
    {
      id: 'result-c',
      title: 'Agence XYZ',
      subTitle: 'Structure',
      actif: true,
      rows: [
        row(cell('SIRET', '12345678901234')),
      ],
      actions: [
        {
          lib: 'Associer',
          icon: 'fal fa-link',
          fields: [],
          urls: {
            autoSubmitUrl: '/form/submit/live-search-affect',
            fieldsUrl: null,
          },
        },
      ],
    },
  ],
};

/** @type {ApiLiveSearchErrorResponse} */
export const mockLiveSearchError400 = {
  message: 'Recherche invalide : au moins un champ live search doit être renseigné.',
};

/** @type {ApiLiveSearchResponse} */
export const mockLiveSearchDefault = mockLiveSearchMultiple;
